<div class="header-group icon-left icon-m ui-icon-config">
    <h2>{{msg 'behavior'}}</h2>
</div>
<div class="inlineGroup fields">
    <field-text name="maxDistance" format="distance" required="true"></field-text>
</div>
